import { IForm } from 'core-components/classes/models/IForm'

export function ExpressionParser(expression: string, data: IForm, showSource: boolean): string {
  const result = expression.match(/\[([a-zA-Z0-9\.\(\[\])_]*)\]/)
  if (result) {
    if (result[1] && result[1].indexOf('(') > -1) {
      const transformation = result[1].match(/\(([a-zA-Z0-9\.\(\[\])_]*)\)/)
      if (transformation) {
        const method = result[1].substr(0, transformation.index)
        const parsed =
          transformation[1].indexOf('[') > -1
            ? eval(ExpressionParser(`[${transformation[1]}]`, data, showSource))
            : ExpressionParser(`[${transformation[1]}]`, data, showSource)
        switch (method) {
          case 'value':
            return data.value(parsed)
          case 'encode':
            return ExpressionParser(
              expression.replace(
                result[0],
                getParsedOrDefault(encodeURIComponent(parsed), result[0].slice(1, -1), showSource)
              ),
              data,
              showSource
            )
          default:
            return ExpressionParser(
              expression.replace(
                result[0],
                getParsedOrDefault(parsed, result[0].slice(1, -1), showSource)
              ),
              data,
              showSource
            )
        }
      }
    } else {
      const way = result[1].split('.')
      let value = data[way[0]] || ''
      if (value) {
        for (let i = 1; i < way.length; i++) {
          value = value[way[i]]
          if (!value) {
            value = ''
          }
        }
      }
      return ExpressionParser(
        expression.replace(
          result[0],
          getParsedOrDefault(value, result[0].slice(1, -1), showSource)
        ),
        data,
        showSource
      )
    }
  }
  return expression
}

function getParsedOrDefault(parsed: string, def: string, showSource: boolean): string {
  if (showSource) {
    return parsed || def
  }
  return parsed
}
